import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import apiClient from '@/lib/apiClient';

export interface CashflowStatusBreakdown {
  totalInvoiceCount: number;
  totalInvoiceAmount: number;
  totalDeductionCount: number;
  totalDeductionAmount: number;
  paidOnTermsCount: number;
  paidOnTermsAmount: number;
  c2foEarlyPaidCount: number;
  c2foEarlyPaidAmount: number;
  c2foEarlyPaidDiscount: number;
  futureDueCount: number;
  futureDueAmount: number;
  pastDueCount: number;
  pastDueAmount: number;
  incomingCashCount: number;
  incomingCashAmount: number;
  collectedCount: number;
  collectedAmount: number;
  remainingCount: number;
  remainingAmount: number;
}

export interface CashflowPeriodItem {
  periodStart: string;
  periodEnd: string;
  totals: CashflowStatusBreakdown;
  byCustomer: (CashflowStatusBreakdown & { makerOrganizationUuid: string })[];
}

export interface BuyerCashflowData {
  aggregatedAt: string;
  currency: string;
  includesCurrencies: string[];
  datacentersQueried: string[];
  totals: CashflowStatusBreakdown;
  byCustomer: (CashflowStatusBreakdown & { makerOrganizationUuid: string })[];
  byPeriod: {
    byDay: CashflowPeriodItem[];
  };
}

export interface BuyerCashflowParams {
  effectiveDueDateFrom: string;
  effectiveDueDateTo: string;
  targetCurrency?: string;
}

const fetchBuyerCashflow = async (params: BuyerCashflowParams): Promise<BuyerCashflowData> => {
  const queryString = qs.stringify(params);
  const response = await apiClient
    .get(`api/invoice-hub/v1/buyer-cashflow?${queryString}`)
    .json<{ data: BuyerCashflowData }>();
  return response.data;
};

export const useBuyerCashflow = (params: BuyerCashflowParams) =>
  useQuery({
    queryKey: ['financeiq-widget-cashflow', params],
    queryFn: () => fetchBuyerCashflow(params),
    retry: 1,
    staleTime: 1000 * 60 * 60 * 24,
  });
